/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { HttpHeaderService } from './http-header.service';
import { Params, ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  token: string;
  constructor(private _HttpHeaderService: HttpHeaderService, private _ActivatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    console.log("Release date 15th Dec 2021 at 4:30 pm");
  }
}
